function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0.5rem;\n\n  & > span {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import { connect as connectFormik, getIn } from "formik";
import CheckboxGroup from "../../../../checkbox-group";
import { getLocalizedProperty } from "../../../../../utils/i18n";
import Label from "../../../../label";
import { MutedText } from "../../../../text";
var NotesInputContainer = styled.div(_templateObject());
var CheckboxComponent = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(CheckboxComponent, Component);
    var _super = _createSuper(CheckboxComponent);
    function CheckboxComponent() {
        _classCallCheck(this, CheckboxComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderCheckbox = function(checkbox, key, option, isChecked) {
            var _props = _this.props, formik = _props.formik, row = _props.row, renderCheckbox = _props.renderCheckbox, renderMultiplierField = _props.renderMultiplierField;
            var checkboxName = row.id;
            var notesInput = null;
            if (option.allowNotes) {
                var selectedOptionValues = getIn(formik.values, checkboxName) || [];
                var hasSelectedCurrentOption = selectedOptionValues.includes(option.value);
                if (hasSelectedCurrentOption) {
                    var notesName = "".concat(row.id, "_").concat(option.id, "_notes");
                    var value = getIn(formik.values, notesName);
                    if (option.notesType === "multiplier" ? isNaN(value) : !value) {
                        value = "";
                    }
                    var type = option.notesType === "multiplier" ? "number" : "text";
                    var multiplierProps = {
                        type: type,
                        name: notesName,
                        onChange: formik.handleChange,
                        label: getLocalizedProperty(option, "notesHint"),
                        value: value,
                        min: "0"
                    };
                    notesInput = /*#__PURE__*/ React.createElement(NotesInputContainer, {
                        "data-testid": "checkbox-row-notes-container__".concat(option.id)
                    }, renderMultiplierField === null || renderMultiplierField === void 0 ? void 0 : renderMultiplierField(multiplierProps));
                }
            }
            if (renderCheckbox) {
                return renderCheckbox({
                    key: key,
                    checkbox: checkbox,
                    notesInput: notesInput,
                    option: option,
                    isChecked: isChecked
                });
            }
            return /*#__PURE__*/ React.createElement("div", {
                key: key
            }, checkbox, notesInput);
        };
        return _this;
    }
    var _proto = CheckboxComponent.prototype;
    _proto.render = function render() {
        var ref, ref1, ref2;
        var _props = this.props, row = _props.row, formik = _props.formik, allowHelpText = _props.allowHelpText, getOptions = _props.getOptions;
        var name = row.id;
        var values = getIn(formik.values, name) || [];
        var touched = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        var rowLabel = getLocalizedProperty(row, "label");
        var label = ((ref = row.options) === null || ref === void 0 ? void 0 : ref.isRequired) ? "* ".concat(rowLabel) : rowLabel;
        var helpText = allowHelpText ? row.description : "";
        var hasQuestionnaire = (ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.hasQuestionnaire;
        if (!hasQuestionnaire) {
            var ref3;
            var rowControl = row.control && typeof row.control === "string" ? JSON.parse(row.control) : row.control;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Label, null, label), helpText && /*#__PURE__*/ React.createElement(MutedText, null, helpText), rowControl === null || rowControl === void 0 ? void 0 : (ref3 = rowControl.map) === null || ref3 === void 0 ? void 0 : ref3.call(rowControl, function(item) {
                var itemData = JSON.parse(item);
                return /*#__PURE__*/ React.createElement("div", {
                    key: itemData.label
                }, itemData.label);
            }));
        }
        return /*#__PURE__*/ React.createElement(CheckboxGroup, {
            name: name,
            label: label,
            options: (getOptions === null || getOptions === void 0 ? void 0 : getOptions(((ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.items) || [])) || [],
            onChange: formik.handleChange,
            values: values,
            renderCheckbox: this.renderCheckbox,
            helpText: helpText,
            error: touched && error,
            vertical: true,
            formikValues: formik.values
        });
    };
    return CheckboxComponent;
}(Component);
CheckboxComponent.defaultProps = {
    getOptions: function(options) {
        return options;
    }
};
CheckboxComponent.propTypes = {
    getOptions: propTypes.func,
    renderCheckbox: propTypes.func
};
export default connectFormik(CheckboxComponent);
